///
/// Story
///
export function dispatchStoryShown(player) {
  dispatchPlayerEvent(player, 'sw.story.shown');
}

export function dispatchStoryStart(player) {
  dispatchPlayerEvent(player, 'sw.story.start', {
    variant: player.variant
  });
}

export function dispatchStoryEnd(player) {
  dispatchPlayerEvent(player, 'sw.story.end', {
    variant: player.variant
  });
}

///
/// Variants
///

/**
 * Stores a numeric ID to match variant events
 * originating from the same variant viewing.
 * Gets incremented on each start and will be sent
 * alongside all variant events
 * @type {Number}
 */
let variantViewingId = 0;

export function dispatchVariantStart(player) {
  variantViewingId = variantViewingId + 1;

  dispatchPlayerEvent(player, 'sw.variant.start', {
    variant: player.variant,
    variantViewingId
  });
}

export function dispatchVariantProgress(player, detail) {
  dispatchPlayerEvent(player, 'sw.variant.progress', {
    variant: player.variant,
    variantViewingId,
    ...detail
  });
}

///
/// Choices
///
export function dispatchChoiceSelected(player, detail) {
  dispatchPlayerEvent(player, 'sw.choice.selected', {
    variant: player.variant,
    variantViewingId,
    ...detail
  });
}

///
/// Choices
///
export function dispatchContextUpdate(player, context) {
  dispatchPlayerEvent(
    player,
    'sw.advancedlogic.updateContext',
    { context }
  );
}

let start;

function dispatchPlayerEvent(player, eventName, detail = {}) {
  const firstEvent = !start;
  if (firstEvent) {
    start = Date.now();
  }
  const event = new CustomEvent(eventName, {
    bubbles: true,
    detail: {
      // Avoid possible slight timing discrepency on first event
      timestamp: firstEvent ? 0 : Date.now() - start,
      ...detail
    }
  });
  player.el().dispatchEvent(event);
}
